const useColorsLogic = () => {
  const apiRoute = "colors";
  const onlyForm = undefined;

  const initFields = [
    {
      name: "name",
      label: "Color Name",
      type: "text",
      isRequired: true,
      err: "Color Name is required",
    },
    {
      name: "color",
      label: "Color Picker",
      type: "color",
      isRequired: true,
      err: "Color Picker Name is required",
    },
    // Add more fields as needed
  ];
  //Roles
  const admin = process.env.REACT_APP_ADMIN_ROLE;
  const managerRole = process.env.REACT_APP_MANAGER_ROLE;
  const financeRole = process.env.REACT_APP_FINANCE_ROLE;
  ///Add,Delete,Edit Roles
  const addRoles = [admin, managerRole, financeRole];
  const deleteRoles = [admin, managerRole, financeRole];
  const editRoles = [admin, managerRole, financeRole];

  const getPromises = (temp) => {
    return [];
  };
  return {
    apiRoute,
    addRoles,
    editRoles,
    deleteRoles,
    initFields,
    getPromises,
    onlyForm,
  };
};

export default useColorsLogic;
